import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=f2aa83b6&"
import script from "./EmployeeList.vue?vue&type=script&lang=ts&"
export * from "./EmployeeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports